import {
  IsOptional,
  IsArray,
  ArrayMinSize,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { IAdapterAutoDependenciesAction } from "./adapter-auto-dependencies-action.interface";
import { QueryDto } from "../query";

export class AdapterAutoDependenciesActionDto
  implements IAdapterAutoDependenciesAction
{
  @IsOptional()
  folder_id?: string | null;

  @IsArray()
  @ArrayMinSize(1)
  operation_ids: string[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;
}
